import { Avatar, Stack } from '@mui/material';
import { LoadingThreeDotsGIF } from 'Images';

export const Loading = () => {
  return (
    <Stack
      alignItems='center'
      sx={{
        p: '40px 0',
      }}
    >
      <Avatar
        alt=''
        src={LoadingThreeDotsGIF}
        sx={{
          width: '140px',
          height: '57px',
        }}
      />
    </Stack>
  );
};
